import { createFileRoute } from "@tanstack/react-router";

const Route = createFileRoute("/")({ component: () => null });

export { Route };
